module.exports = __webpack_public_path__ + "img/no_cover.5c4a5fdd.png";